import React, { createRef } from "react";
import { InputFactory, InputJson } from "nq-component";
import BaseFormPage from "../../../../../base/BaseFormPage";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import OfficeFormPresenter from "../../../../OrganizationaStructure/offices/office-form/OfficeFormPresenter";
import NavBar from "../../../../../components/navigation";
import withRouter from "../../../../../withRouter";
import ViewTrainees from "./ViewTrainees";

class TraineesForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      count: "",
    };
    this.presenter = new OfficeFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
    this.chidRef = createRef();
  }

  // async componentDidUpdate(prevProps, prevState) {
  //   if (prevState.object !== this.state.object) {
  //     await this.TraineesData();
  //   }
  // }

  // async TraineesData() {
  //   const { object } = this.state;
  //   const query = {
  //     where: {
  //       Firstname: object.Firstname,
  //       Middlename: object.Middlename,
  //       surname: object.surname,
  //     },
  //   };
  //   const viewTrainees = await findObjectUseCase().execute("attendees", query);
  //   this.setState({ viewTrainees });
  // }

  getCollectionName() {
    return "employees";
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const object = this.state.object;
    console.log("Object", object);
    const advanced = this.state.advanced;
    if (!schema) return <h1>no schema</h1>;
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100 mt-5">
            <div className="p-lg-4">
              <div>
                <div className="row">
                  {advanced ? (
                    <InputJson
                      defaultValue={object}
                      onChange={this.onChangeObject.bind(this)}
                      rows="15"
                    />
                  ) : (
                    <>
                      <div className="pe-5 ps-5">
                        <div
                          className="d-flex mb-4"
                          style={{ borderBottom: "1px solid #d3d3d3" }}
                        >
                          <p style={{ fontSize: "14px", color: "grey" }}>
                            You are here: Home &gt; Learning and Development
                            &gt;{" "}
                            <span style={{ color: "#333" }}>
                              Training Status
                            </span>
                          </p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <blockquote className="blockquote">
                            <h6>
                              First Name: <b>{object.Firstname}</b>
                            </h6>
                            <h6>
                              Middle Name: <b>{object.Middlename}</b>
                            </h6>
                            <h6>
                              Last Name: <b>{object.surname}</b>{" "}
                            </h6>
                          </blockquote>
                          <div className="d-block justify-content-end gap-2">
                            <button
                              className="btn btn-primary"
                              onClick={this.navigateBack.bind(this)}
                            >
                              <i className="bi bi-arrow-return-left" /> Back
                            </button>
                          </div>
                        </div>

                        <hr />
                        {Object.keys(object).length > 0 && (
                          <ViewTrainees
                            object={this.state.object}
                            ref={this.chidRef}
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(TraineesForm);
